import React, { useEffect, useRef, useState } from "react";
import { RaceDTO } from "../../interfaces/RaceDTO";
import { AthleteDTO } from "../../interfaces/AthletesDTO";
import { eventBus } from "../../services/eventHandler";
import "./biostyle.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { BiosTableRow } from "./BiosTableRow";
import BiosTableRowShooting from "./BiosTableRowShooting";
import { ViewType } from "../../interfaces/internal/ViewProps";
import BiosShootingDiagram from "./BiosShootingDiagram";
import { useBlade } from "../../services/BladeProvider";
import BiosHistoricResult from "./BiosHistoricResult";
import { useFavorites } from "../../services/FavoritesProvider";
import { Button } from "react-bootstrap";
import BiosSearch from "./BiosSearch";

interface Props {
  race: RaceDTO;
  vType: ViewType;
}

const Bios = ({ race, vType }: Props) => {
  const runtTimeRef = useRef<number | null>(null);
  const [athlete, setAthlete] = useState<AthleteDTO | null>(null);
  const [selctedTab, setSelectedTab] = useState<string | null>(null);
  const [lastCount, setLastCount] = useState<number>(0);
  const [searchedAthlete, setSearchedAthlete] = useState<AthleteDTO | null>(
    null
  );
  const athleteRef = useRef<AthleteDTO | null>();
  const searchedAthleteRef = useRef<AthleteDTO | null>();
  const { getUserType, getAccesToken } = useBlade();
  const { getAthleteInfo, getAthleteInfoFIS } = useFavorites();
  let lstRank: number = -1;
  useEffect(() => {
    // Here's your "hook by ID"

    const handler = (ath: AthleteDTO | null) => {
      // console.log(searchedAthlete);
      if (ath !== null && searchedAthleteRef.current == null) {
        setAthlete(ath);
        setLastCount(Object.keys(ath.Times).length);
      }
    };

    if (vType === ViewType.athletebioTV) {
      eventBus.on(`tvfollow`, handler);
    } else {
      eventBus.on(`selctedathlete`, handler);
    }

    const startInterval = () => {
      if (runtTimeRef.current !== null) return;
      runtTimeRef.current = window.setInterval(() => {
        updateInterval();
      }, 1000);
    };
    startInterval();

    return () => {
      // Cleanup to avoid memory leaks
      if (vType === ViewType.athletebioTV) {
        eventBus.on(`tvfollow`, handler);
      } else {
        eventBus.removeListener(`selctedathlete`, handler);
      }
      if (runtTimeRef.current !== null) {
        window.clearInterval(runtTimeRef.current);
        runtTimeRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    athleteRef.current = athlete;
  }, [athlete]);

  const updateInterval = () => {
    if (athleteRef.current === null || athleteRef.current === undefined) {
      return;
    }
    let ath = athleteRef.current; // race.Class[athleteRef.current.ClassID].Level[athleteRef.current.Level].Athletes[athleteRef.current.Startno];
    if (Object.keys(athleteRef.current.Times).length !== lastCount) {
      setAthlete(ath);
      setLastCount(Object.keys(athleteRef.current.Times).length);
    }
  };
  const athleteSearch = (ath: AthleteDTO | null) => {
    setAthlete(ath);
    setSearchedAthlete(ath);
    searchedAthleteRef.current = ath;
  };

  return (
    <div className="bios-view">
      <div className="bios-search pb-2 pt-2">
        <BiosSearch athleteSelect={athleteSearch} race={race} />
      </div>
      <div className="bios-athlete">
        <div className="bios-image" id="bios_image_RV_3">
          &nbsp;
        </div>
        <div className="bios-name">
          <div className="bios-names">
            <span className="bios-header">Firstname:</span>
            <span className="bios-info" id="bios_firstname_RV_3">
              {athlete ? athlete.FirstName : ""}
            </span>
          </div>
          <div className="bios-names">
            <span className="bios-header">Lastname:</span>
            <span className="bios-info" id="bios_lastname_RV_3">
              {athlete ? athlete.LastName : ""}
            </span>
          </div>
          <div className="bios-names" style={{ display: "none" }}>
            <span className="bios-header">Birthyear:</span>
            <span className="bios-info" id="bios_age_RV_3">
              {athlete ? athlete.Birth?.toString() : ""}
            </span>
          </div>
          <div className="bios-names">
            <span className="bios-header">Team:</span>
            <span className="bios-info" id="bios_team_RV_3">
              {athlete ? athlete.Club : ""}
            </span>
          </div>
          <div className="bios-names">
            <span className="bios-header">Info:</span>
            <span className="bios-info" id="bios_info_RV_3">
              {athlete ? getAthleteInfoFIS(athlete.FisCode) : ""}
              {/* {athlete && getAccesToken === "c2FrbmFyY2Fyb2xpbg==" ? ("DIV4" in athlete.ExtraInfo ? athlete.ExtraInfo["DIV4"] : "ej in") : "" } */}
            </span>
          </div>
        </div>
      </div>
      <div className="bios-race-data">
        <Tabs
          defaultActiveKey="home"
          id="uncontrolled-tab-example"
          className="mb-3"
          onSelect={(eventKey) => setSelectedTab(eventKey)}
        >
          <Tab eventKey="home" title="Race data">
            <table>
              <thead>
                <tr>
                  <th className="bios-time-row-position">Timing pos</th>
                  <th className="bios-time-row-rank">Rank</th>
                  <th className="bios-time-row-trend">Trend</th>
                  <th className="bios-time-row-time">Runtime</th>
                  <th className="bios-time-row-diff">diff</th>
                </tr>
              </thead>
              <tbody>
                {athlete ? (
                  Object.keys(athlete.Times).map((key) => {
                    if (parseInt(key) > 999) {
                      return true;
                    }
                    let lastRank: number = parseInt(lstRank.toString());
                    lstRank = athlete.Times[parseInt(key)].RankClass;
                    return (
                      <BiosTableRow
                        key={key + "-" + athlete.ID}
                        lastRank={lastRank}
                        time={athlete.Times[parseInt(key)]}
                        athlete={athlete}
                        tposes={
                          key in
                          race.Class[athlete.ClassID].Level[athlete.Level]
                            .TimePos
                            ? race.Class[athlete.ClassID].Level[athlete.Level]
                                .TimePos[parseInt(key)]
                            : null
                        }
                        timingPrecision={race.Class[athlete.ClassID].TimeFormat}
                      />
                    );
                  })
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </Tab>
          <Tab eventKey="profile" title="Analytics">
            <table>
              <thead>
                <tr>
                  <th className="bios-time-row-position">Timing pos</th>
                  <th className="bios-time-row-rank">Rank</th>
                  <th className="bios-time-row-time">Runtime</th>
                  <th className="bios-time-row-diff">diff</th>
                </tr>
              </thead>
              <tbody>
                {athlete ? (
                  Object.keys(athlete.Times).map((key) => {
                    if (parseInt(key) <= 999) {
                      return true;
                    }
                    return (
                      <BiosTableRow
                        key={key + "-" + athlete.ID}
                        lastRank={-10}
                        time={athlete.Times[parseInt(key)]}
                        athlete={athlete}
                        tposes={
                          key in
                          race.Class[athlete.ClassID].Level[athlete.Level]
                            .TimePos
                            ? race.Class[athlete.ClassID].Level[athlete.Level]
                                .TimePos[parseInt(key)]
                            : null
                        }
                        timingPrecision={race.Class[athlete.ClassID].TimeFormat}
                      />
                    );
                  })
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </Tab>
          <Tab eventKey="images" title="Images">
            <div>
             <span>Image for newspapers</span>
              <img
                src={"test/" + athlete?.Startno + "_news.png"}
                style={{
                  width: "90%",
                  borderBottom: "2px solid black",
                  marginBottom: "10px",
                }}
              />
            </div>
            <div>
            <span>Image for socialmedia</span>
            <img
              src={"test/" + athlete?.Startno + "_adv.png"}
              style={{ width: "90%" }}
            />
            </div>
          </Tab>
          {/* <Tab eventKey="relay" title="Relay">
            <table>
              <thead>
                <tr>
                  <th style={{ width: "30px" }} className="">Leg</th>
                  <th style={{ minWidth: "300px" }} className="">Name</th>

                </tr>
              </thead>
              <tbody>

                {athlete ? (
                  Object.keys(athlete.RealyAthletes).map((key, index) => {
                    return (
                      <tr key={index}>
                        <td>{key}</td>
                        <td >{athlete.RealyAthletes[parseInt(key)].FormatedName}</td>
                      </tr>
                    );
                  })
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </Tab> */}
          {race.Sport !== "BT" ? (
            <Tab eventKey="historicresult" title="Historic">
              <table>
                <thead>
                  <tr>
                    <th className="bios-historic-time-row-position">Race</th>
                    <th className="bios-historic-time-row-date">Date</th>
                    <th className="bios-historic-time-row-rank">Rnk</th>
                    <th className="bios-historic-time-row-time">Runtime</th>
                    <th className="bios-historic-time-row-diff">diff</th>
                  </tr>
                </thead>
                <tbody>
                  {athlete && selctedTab === "historicresult" ? (
                    <BiosHistoricResult
                      key={"historics"}
                      fiscode={athlete.FisCode}
                    />
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            </Tab>
          ) : null}
          {race.Sport === "BT" ? (
            <Tab eventKey="shooting" title="Shooting">
              <table>
                <thead>
                  <tr className="bios-shooting-row">
                    <th className="bios-shooting-row-position">Shoot pos</th>
                    <th className="bios-shooting-row-time">1.</th>
                    <th className="bios-shooting-row-time">2.</th>
                    <th className="bios-shooting-row-time">3.</th>
                    <th className="bios-shooting-row-time">4.</th>
                    <th className="bios-shooting-row-time">5.</th>
                    <th className="bios-shooting-row-time">Tot</th>
                    <th className="bios-shooting-row-target">Target</th>
                  </tr>
                </thead>
                <tbody>
                  {athlete ? (
                    Object.keys(athlete.Shooting).map((key) => (
                      <BiosTableRowShooting
                        key={key + "-sht-" + athlete.ID}
                        shooting={
                          key in athlete.Shooting
                            ? athlete.Shooting[parseInt(key)]
                            : null
                        }
                      />
                    ))
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>

              {getUserType()! > 3 || athlete === null ? (
                <></>
              ) : (
                <BiosShootingDiagram
                  startno={athlete.Startno}
                  shootings={athlete.Shooting}
                />
              )}
            </Tab>
          ) : null}
        </Tabs>
      </div>
    </div>
  );
};

export default Bios;
